export type VerticalAlignmentType = "top" | "middle" | "bottom";

export const availableVerticalAlignment: VerticalAlignmentType[] = [
  "top",
  "middle",
  "bottom"
];
